module.exports = function() {
  return new Worker(__webpack_public_path__ + "83e29b7e53d9a0782c02.worker.js");
};